import React, {useState} from 'react'
import ComponentRegistry from '../registry';
import ProgressBubbles from '../partials/ProgressBubbles';
import ProgressBar from '../partials/ProgressBar';

export default function Quiz(props) {
  const [questionIndex, setQuestionIndex] = useState(0);
  const [answered, setAnswered] = useState(0);
  if (!props.data.questions) return 'invalid JSON for Quiz.js, this model requires a questions node';

  const onQuestionComplete = () => {
    if (!nextQuestion()) {
      props.onComplete();
    }
  }

  const nextQuestion = () => {
    if (questionIndex + 1 < props.data.questions.length) {
      setQuestionIndex(questionIndex + 1);
      setAnswered(0);
      return true;
    }
    return false;
  }

  // const prevQuestion = () => {
  //     if(questionIndex > 0){
  //         setQuestionIndex(questionIndex - 1);
  //     }
  // }

  return (
    <div className={`Quiz ${props.data.class}`}>
      <h1 dangerouslySetInnerHTML={{__html: props.data.headerText}}></h1>
      <p dangerouslySetInnerHTML={{__html: props.data.bodyText}}></p>
      <ProgressBubbles total={props.data.questions.length} current={questionIndex + 1}/>
      <ProgressBar percentage={100 * (questionIndex + answered) / props.data.questions.length}/>
      {ComponentRegistry(props.data.questions[questionIndex].type, {
        onComplete: onQuestionComplete,
        data: props.data.questions[questionIndex],
        key: questionIndex,
        setAnswered: setAnswered
      })}
    </div>
  )
}
